import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  TestConfigOutput
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: ({ name }: TestConfigOutput) => ReactElement | string
  onSuccess?: (data: TestConfigOutput) => void
  onError?: (error: Error) => void
}

const GetTestConfigNameRequest = ({
  id,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/test_configurations/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetTestConfigNameRequest
